import ReactDOM from 'react-dom';
import AppRouter from './routers/AppRouter';
import { Provider } from 'react-redux';
import { store } from './Redux/store';
import 'bootstrap/dist/css/bootstrap.css';
import './styles/styles.css';
import Cookies from 'js-cookie';

const existingTabKey = 'myAppTabKey';

const openedTime = Cookies.get(existingTabKey);

if (openedTime) {
  const currentTime = new Date().getTime();
  // alert('You already have this app open in another tab');
  const threshold = 60000; // 60 seconds

  if (currentTime - openedTime > threshold) {
    // Tab was probably closed accidentally, reset the flag
    Cookies.remove(existingTabKey);
  }
} else {
  const currentTime = new Date().getTime();
  Cookies.set(existingTabKey, currentTime);
  ReactDOM.render(
    <Provider store={store}>
      <AppRouter />
    </Provider>,
    document.getElementById('root')
  );

  window.addEventListener('beforeunload', () => {
    Cookies.remove(existingTabKey);
  });
}
